<span *ngIf="salaryMin && salaryMax" class="keyword">
  <svg-icon class="keyword__icon" icon="exp-purse" width="1.1em"></svg-icon>
  <span *ngIf="salaryMin && salaryMax" itemprop="baseSalary" itemscope itemtype="http://schema.org/MonetaryAmount">
    <meta itemprop="currency" content="EUR" />
    <meta itemprop="minValue" [content]="salaryMin * 1000" />
    <meta itemprop="maxValue" [content]="salaryMax * 1000" />

    <span class="header__tag">{{ salaryMin }}</span
    >k&nbsp;-&nbsp;<span class="header__tag">{{ salaryMax }}</span
    >k
  </span></span
>
